export default "__VITE_ASSET__BI0L3efO__"